"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var l = require("lenovo");
var utility_1 = require("../utility");
var utility_2 = require("../../commoncomponents/src/utility");
var IsHaveItemInCartKey = "IsHaveItemInCart";
var currentCartFlagKey = "CurrentCartFlag";
var WpsShop = /** @class */ (function () {
    function WpsShop() {
        var _this = this;
        this.CheckAddItem = function (cart) {
            var cartFlag = cart.CartFlag;
            var result = true;
            if (utility_2.IsUsingUnifiedCart()) {
                var currentCartFlag = Cookies.get(currentCartFlagKey);
                if (currentCartFlag && _this.IsHaveItemInCart(cartFlag)) {
                    //If want to add a part material
                    if (cartFlag == utility_1.CartFlag.Parts) {
                        //If the part is not in the current shopping cart
                        if (currentCartFlag != utility_1.CartFlag.Parts)
                            result = false;
                    }
                    else {
                        if (currentCartFlag == utility_1.CartFlag.Parts)
                            result = false;
                    }
                }
            }
            if (!result)
                window["onHandleShowError"](l.Translator.translate("item cannot add to cart"), l.Translator.translate("x can not purchased", cart.Id));
            return result;
        };
        this.GoShopping = function (cartFlag) {
            var url = window.location.href.toLocaleLowerCase();
            if (url.indexOf("/accessorieslookup") < 0 && url.indexOf("/parts") < 0 && url.indexOf("/warranty")) {
                if (cartFlag == utility_1.CartFlag.Parts)
                    location.href = l.UrlUtility.getFullPath("/partslookup");
                else if (cartFlag == utility_1.CartFlag.Accessories)
                    location.href = l.UrlUtility.getFullPath("/accessorieslookup");
                else if (cartFlag == utility_1.CartFlag.Services)
                    location.href = l.UrlUtility.getFullPath("/warrantylookup");
            }
            else {
                if (((cartFlag == utility_1.CartFlag.Accessories || cartFlag == utility_1.CartFlag.Parts)) && window["onHandleSwitchPartsTab"])
                    window["onHandleSwitchPartsTab"](cartFlag == 0);
            }
        };
    }
    WpsShop.prototype.AddToCart = function (cart, callback) {
        if (callback === void 0) { callback = null; }
        if (cart.CartFlag != undefined) {
            if (!this.CheckAddItem(cart))
                return;
            window["onHandleShowTopCart"](false);
            if (!utility_2.IsUsingUnifiedCart() && cart.CartFlag == utility_1.CartFlag.Accessories && !l.AccountAuthentication.isLogin())
                window["onHandleShowLogin"]();
            else
                window["onHandleRenderAddToCart"](cart, callback);
        }
    };
    WpsShop.prototype.GoToCheckOut = function (cartFlag, isGuestCheckOut) {
        if (isGuestCheckOut === void 0) { isGuestCheckOut = false; }
        window["onHandleShowTopCart"](false);
        window["onHandleShowCheckOutLoading"](true);
        //Record the page 'click on the shopping cart view' button
        if (!Cookies.get("clickViewPage"))
            Cookies.set("clickViewPage", location.href.toString(), { domain: ".lenovo.com", path: "/" });
        if (!isGuestCheckOut && !l.AccountAuthentication.isLogin()) {
            location.href = l.UrlUtility.getFullPath("/shoplogin");
            return false;
        }
        this.GetToken(cartFlag);
    };
    WpsShop.prototype.GetToken = function (cartFlag) {
        $.getJSON(l.UrlUtility.getFullServicesPath("/Shop/GetCheckOutPostData?cartFlag=" + cartFlag)).then(function (response) {
            var rs = response;
            if (rs.code === 200) {
                var returnUrl = Cookies.get("clickViewPage");
                if (!returnUrl || returnUrl.toLocaleLowerCase().indexOf("/shoplogin") > -1)
                    returnUrl = location.origin + "/" + l.CultureUtility.getCurrentCountry() + "/" + l.CultureUtility.getCurrentLanguage() + "/partslookup";
                var errorUrl = location.origin + "/" + l.CultureUtility.getCurrentCountry() + "/" + l.CultureUtility.getCurrentLanguage() + "/handlemessage";
                $("#checkoutForm").attr("action", rs.data.Url);
                $("#token").val(rs.data.Token);
                $("#anonymous").val(rs.data.Anonymous);
                $("#userid").val(rs.data.UserID);
                $("#userId").val(rs.data.UserID);
                $("#guid").val(rs.data.Guid);
                $("#errorUrl").val(errorUrl);
                $("#partsalesTargetUrl").val(returnUrl);
                Cookies.remove('clickViewPage', { domain: ".lenovo.com", path: "/" });
                $("#checkoutForm").submit();
            }
            else if (rs.code === 600) {
                window["onHandleShowLogin"]();
                window["onHandleShowCheckOutLoading"](false);
            }
        });
    };
    //from shoplogin,user is anonymously => login, we need transfer the items of an anonymous shopping cart to the current shopping cart of the login user
    WpsShop.prototype.RefreshCart = function (callback) {
        $.getJSON(l.UrlUtility.getFullServicesPath("/Shop/GetCartData") + "?_=" + new Date().getTime() + "&&cartFlag=" + utility_1.CartFlag.Parts).then(function (response) {
            var rs = response;
            if (rs.code === 200) {
                callback();
            }
            else if (rs.code === 600) {
                window["onHandleShowLogin"]();
            }
            else {
                l.DTM.Lmd.pusherrorinfTrack("Refresh cart error", rs.msg);
                window["onHandleError"](l.Translator.translate("ps request error"), rs.msg);
                window["onHandleShowCheckOutLoading"](false);
            }
        });
    };
    WpsShop.prototype.ShowPart = function (partID, cartFlag) {
        var isPartsPage = window.location.href.toLowerCase().indexOf("/partslookup") > -1;
        var isAccessoryPage = window.location.href.toLowerCase().indexOf("/accessorieslookup") > -1;
        window["onHandleShowTopCart"](false);
        switch (cartFlag) {
            case utility_1.CartFlag.Parts:
                if (isPartsPage && window['onHandleSearchByPart'])
                    window['onHandleSearchByPart'](partID);
                else
                    window.location.href = l.UrlUtility.getFullPath("/partslookup?s=cart&&partid=" + partID);
                break;
            case utility_1.CartFlag.Accessories:
                if (isAccessoryPage && window['onHandleSearchByPart'])
                    window['onHandleSearchByPart'](partID);
                else
                    window.location.href = l.UrlUtility.getFullPath("/accessorieslookup?partid=" + partID);
                break;
        }
    };
    WpsShop.prototype.IsHaveItemInCart = function (cartFlag) {
        var key = IsHaveItemInCartKey;
        if (!utility_2.IsUsingUnifiedCart())
            key = "" + key + cartFlag;
        return Cookies.get(key) == "TRUE";
    };
    WpsShop.prototype.SetCookiesForCart = function (cartFlag, isHaveItemInCart) {
        var key = IsHaveItemInCartKey;
        if (!utility_2.IsUsingUnifiedCart())
            key = "" + key + cartFlag;
        if (isHaveItemInCart)
            Cookies.set(currentCartFlagKey, cartFlag.toString().toUpperCase(), { domain: ".lenovo.com", path: "/" });
        else
            Cookies.remove(currentCartFlagKey);
        Cookies.set(key, isHaveItemInCart.toString().toUpperCase(), { domain: ".lenovo.com", path: "/" });
    };
    return WpsShop;
}());
var WPSShop = new WpsShop();
exports.WPSShop = WPSShop;
window["WPSShop"] = WPSShop;
